import React from "react";
import { useParams } from "react-router-dom";
import { ProjectList } from "../../helpers/ProjectList";
import "../../styles/ProjectDisplay.css";
import "../../styles/projects/RedBagNew.css";
import Slider from "../../components/Slider";
import { RBnewImg } from "../../helpers/SliderImages";
import { Link } from "react-router-dom";

function RedBagNew() {
  const { id } = useParams();
  const project = ProjectList[0];
  return (
    <div className="project">
      <div className="project-title">
        <h1 style={{ color: "#de1a1a" }}> {project.name}</h1>
      </div>
      <Slider mediaArray={RBnewImg} />
      <div className="projectContent">
        <p>
          <b>Skills:</b> {project.skills}
        </p>
        <p>
          <b>Overview:</b> Building on the foundation of the original system{" "}
          <Link className="textLink" to="/project/1">
            (found here)
          </Link>
          , I am now working on a new and improved version of the Red Bag KC
          database alongside my brother and dad, both experienced developers. We
          are leveraging the latest version of AWS Amplify while maintaining
          much of the same tech stack to ensure a smooth transition. Currently,
          we are in the wireframing phase, using Figma’s developer extension to
          efficiently convert designs into code. Our goal is to enhance
          performance, optimize workflows, and introduce new features that make
          the platform even more intuitive and powerful. This version will
          include multiple sidebar tabs for better navigation, real-time
          synchronization across all clients for seamless collaboration, and an
          overall improved user experience. By refining both the UI and backend,
          we aim to make the system faster, more scalable, and easier to
          use—ensuring Red Bag KC can continue its mission with greater
          efficiency than ever before.
        </p>
      </div>
    </div>
  );
}

export default RedBagNew;
